import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[cappusPreventClick]',
})
export class PreventClickDirective {
  @HostListener('click', ['$event'])
  onClick($event: Event): boolean {
    $event.preventDefault();
    $event.stopPropagation();

    return false;
  }
}
